import { endpoints } from 'api/endpoints'
import { GetArrayResponse } from 'interfaces/api.interfaces'
import { Granularity } from 'interfaces/api/granularities.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetArrayResponse<Granularity> => {
  const { data: response } = await axios.request<Granularity[]>({
    method: 'GET',
    url: endpoints.granularities.getAll(),
  })
  return response
}

export const granularitiesApi = {
  getAll,
}
